"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatchOptionsToMessageKey = exports.MATCH_OPTIONS = void 0;
const ui_components_1 = require("@groupby/ui-components");
// TODO - EN-4809 - remove after table migration
/** @deprecated */
exports.MATCH_OPTIONS = [ui_components_1.MatchOptions.Include, ui_components_1.MatchOptions.Exclude];
/** @deprecated */
exports.MatchOptionsToMessageKey = {
    [ui_components_1.MatchOptions.Include]: 'MATCH_OPTION_INCLUDE',
    [ui_components_1.MatchOptions.Exclude]: 'MATCH_OPTION_EXCLUDE',
};
